import kebabCase from 'lodash-es/kebabCase'
import React, { useEffect } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

import { Dashboard } from '@components/common'
import { useMediaQueryContext } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { useMenuDrawerContext } from '../../contexts/MenuDrawerContext'
import type { NavigationItem } from '../../hooks/useNavigations'

export type SidebarContentProps = {
  navigations: NavigationItem[]
}

export const SidebarContent = ({ navigations }: SidebarContentProps) => {
  const media = useMediaQueryContext()
  const { activeNavigationGroup, setActiveNavigationGroup, drawerActive } = useMenuDrawerContext()
  const location = useLocation()

  const isMatched = (to: string) =>
    !!matchPath({ path: to, end: to === routing.home }, location.pathname)

  const getMatchingNavigationGroupLabel = () => navigations.find(({ to }) => isMatched(to))?.label

  useEffect(() => {
    if (!drawerActive) {
      const matchingNavigationGroupLabel = getMatchingNavigationGroupLabel()
      matchingNavigationGroupLabel && setActiveNavigationGroup(matchingNavigationGroupLabel)
    }
  }, [drawerActive])

  const renderItem = (
    { label, to, icon, tag, activeIcon, rightIcon, items, as }: NavigationItem,
    parentLabel?: string,
  ) => {
    const hasChildren = !!items?.length
    const matched = isMatched(to)
    const displayChildren =
      hasChildren &&
      ((!media.tablet && activeNavigationGroup === label) || (media.tablet && matched))

    return (
      <Dashboard.Menu.Item
        key={`${kebabCase(label)}-${to}`}
        label={label}
        icon={icon}
        activeIcon={activeIcon}
        rightIcon={rightIcon}
        tag={tag}
        to={!media.tablet && hasChildren ? undefined : to}
        as={as}
        onClick={(e) => {
          e.stopPropagation()

          if (!parentLabel) {
            setActiveNavigationGroup(activeNavigationGroup === label ? null : label)
          }
        }}
      >
        {displayChildren && (
          <Dashboard.Menu>
            {items.map((item) => !item.hidden && renderItem(item, label))}
          </Dashboard.Menu>
        )}
      </Dashboard.Menu.Item>
    )
  }

  return (
    <Dashboard.Menu>{navigations.map((item) => !item.hidden && renderItem(item))}</Dashboard.Menu>
  )
}
